var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { backendClientFactory } from '../../apiClient/backend-api/backendClient';
import { componentMessages } from '../../component-translations';
import SingleAutocomplete from '../Autocomplete/SingleAutocomplete';
import { useUserState } from '../User/UserContext';
export const ChecklistAutocomplete = (props) => {
    const { formatMessage } = useIntl();
    const { 
    // default to checklist-specific messaging
    loadingText = formatMessage(componentMessages['autocomplete.checklist.loading']), noResultsText = formatMessage(componentMessages['autocomplete.checklist.noResults']), moreResultsText = formatMessage(componentMessages['autocomplete.tooManyResults']), placeholder = formatMessage(componentMessages['autocomplete.checklist.placeholder']), label = formatMessage(componentMessages['autocomplete.checklist.label']), } = props;
    const userState = useUserState();
    const api = backendClientFactory(userState.authProvider.getToken);
    const getOptions = useCallback(function getCheckOptions(term = '', limit) {
        return __awaiter(this, void 0, void 0, function* () {
            const checks = yield api.getChecks(term, limit);
            return checks.map((check) => ({
                code: check.id.entityId,
                name: check.name,
                latest: {
                    code: check.code,
                    version: check.id.version,
                },
            }));
        });
    }, [api]);
    return (React.createElement(SingleAutocomplete, Object.assign({}, props, { label: label, loadingText: loadingText, moreResultsText: moreResultsText, noResultsText: noResultsText, placeholder: placeholder, getOptions: getOptions })));
};
//# sourceMappingURL=ChecklistAutocomplete.js.map